/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getTenantLogoAlt, getTenantLogoSrc, getTenantLogoWidth } from '../../tenant-brand.util';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header *ngIf="!careSphereShell && !isCareNavigatorSession" fixed>

        <ngx-header  [ngClass]="{'nursehead':(!isVOPD && isNewCasesheet && (jobCategoryId=='25' || jobCategoryId=='2' || userFlag=='Physician'|| jobCategoryId=='5'||jobCategoryId=='21' ||jobCategoryId=='4' || jobCategoryId=='26' || jobCategoryId=='27' || jobCategoryId=='28' || jobCategoryId=='29' || jobCategoryId=='30' || jobCategoryId=='31' || jobCategoryId=='32' || jobCategoryId=='33' || jobCategoryId=='34' || jobCategoryId=='35' || jobCategoryId=='36' ||  jobCategoryId=='37' || jobCategoryId=='38' || jobCategoryId=='39' || jobCategoryId=='41' || jobCategoryId=='45' || jobCategoryId=='46' || jobCategoryId=='47' || jobCategoryId=='48' || jobCategoryId=='7'))}"></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" *ngIf="(!isNewCasesheet || (jobCategoryId!='25' && jobCategoryId!='2' &&jobCategoryId!='21' && jobCategoryId!='4' && jobCategoryId!='26' &&  jobCategoryId!='27' && jobCategoryId!='28' && jobCategoryId!='29' && jobCategoryId!='30' && jobCategoryId!='31' && jobCategoryId!='32' && jobCategoryId!='33' && jobCategoryId!='34' && jobCategoryId!='35' && jobCategoryId!='36' && jobCategoryId!='37' && jobCategoryId!='38' && jobCategoryId!='39' && jobCategoryId!='41' && jobCategoryId!='43' && jobCategoryId!='44' && jobCategoryId!='45' && jobCategoryId!='46' && jobCategoryId!='47' && jobCategoryId!='48' && jobCategoryId!='7' && userFlag!='Physician' && jobCategoryId!='5')) && vitalPage != 'vitalMonitoring' && !careSphereShell && !isCareNavigatorSession && !(isSaudiBranch && (jobCategoryId=='50' || jobCategoryId=='3'))" tag="menu-sidebar" responsive start>
        <!-- <ng-content select="nb-menu"></ng-content> -->
           <ng-container *ngTemplateOutlet="menuTpl"></ng-container>
      </nb-sidebar>


      <nb-sidebar class="emr-sidebar care-sphere-sidebar custom-case-sphere-sbar" *ngIf="careSphereShell && !isCareNavigatorSession" responsive start>
        <div class="emr-brand">
             <img [src]="logoSrc" [alt]="logoAlt" class="brand-logo so-well-spring-logo" [ngStyle]="{ width: logoWidth }" />
        </div>

        <ng-container *ngTemplateOutlet="menuTpl"></ng-container>
      </nb-sidebar>

      <ng-template #menuTpl>
        <ng-content select="nb-menu"></ng-content>
      </ng-template>



      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer id="foot-id" fixed *ngIf="!isCareNavigatorSession">
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent {
  vitalPage:any;
    constructor(private routerAct: ActivatedRoute) {

    this.routerAct.queryParams.subscribe(params => {
      this.vitalPage = params['fromVitalPage'] || null;
    })
    }

    ngOnInit() {
      this.loadFlags();
    }
  jobCategoryId = localStorage.getItem('jobCategoryId');
  userFlag = localStorage.getItem("userFlag");
  insuranceFlag: boolean = false;
  isVOPD: boolean = localStorage.getItem('tenantType') === 'VOPD';
  wellSpringFlag: boolean = false;

  loadFlags() {
    const flag = localStorage.getItem('InsuranceFlag');
    this.insuranceFlag = flag === 'true';
    // Cross-checked against PatloginUserType (only ever set by the legacy Care-Sphere login)
    // so a stale/leftover WellSpringAppFlag can't misfire WellSpring-only behaviour for that session.
    this.wellSpringFlag = localStorage.getItem('WellSpringAppFlag') === 'true' && !localStorage.getItem('PatloginUserType');
  }

  // Job-category header menus exist only for the NEW casesheet; OLD logins get the normal employee sidebar menu.
  get isNewCasesheet(): boolean {
    return localStorage.getItem('casesheetVersion') === 'NEW';
  }

  get isSaudiBranch(): boolean {
    return localStorage.getItem('LoginCountryCode') === '+966';
  }

  // A WellSpring App session uses the same Care-Sphere shell as an Insurance session,
  // even when it isn't tenant-based (InsuranceFlag false). Pure insurance sessions
  // (wellSpringFlag false) keep their original behaviour unchanged.
  get careSphereShell(): boolean {
    return this.insuranceFlag || this.wellSpringFlag;
  }

  // The Care Navigator portal (well-spring-care-navigator-shell.component.ts) brings its own
  // full-page shell (sidebar/topbar) and has no real menu configured for this component's own
  // nb-menu to populate - without this, the careSphereShell branch above still rendered its own
  // (empty) sidebar/header/footer alongside it. Deliberately keyed off 'employeeRoleUrlSuffix',
  // not 'userType' - InitUserService.initCurrentUser() (run on every app bootstrap, i.e. every
  // browser refresh) overwrites 'userType' with the backend User record's own unrelated numeric
  // value, which flipped this back to the default shell on refresh. employeeRoleUrlSuffix is
  // never touched by InitUserService, so it survives a refresh - see the identical reasoning in
  // PagesComponent.initMenu() and PatientportalloginComponent.submitLogin().
  get isCareNavigatorSession(): boolean {
    return localStorage.getItem('employeeRoleUrlSuffix') === 'care-navigator';
  }

  get logoSrc(): string {
    return getTenantLogoSrc();
  }

  get logoAlt(): string {
    return getTenantLogoAlt();
  }

  get logoWidth(): string {
    return getTenantLogoWidth();
  }
}
